import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { FlameIcon } from './icons/Icons';
export function HookSection() {
  return <section className="relative w-full bg-[#1f2a22] py-16 text-white sm:py-20" data-id="element-136">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-137">
        <Reveal data-id="element-138">
          <motion.div animate={{
          scale: [1, 1.12, 1]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#e0611f]/15 text-[#ff7b39]" data-id="element-139">
            <span className="animate-flicker" data-id="element-140">
              <FlameIcon className="h-9 w-9" strokeWidth={2} data-id="element-141" />
            </span>
          </motion.div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-142">
          <h2 className="mt-6 font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-143">
            ¿Sientes ese carbón encendido en la boca de tu estómago{' '}
            <span className="text-[#ff7b39]" data-id="element-144">justo ahora</span>?
          </h2>
        </Reveal>

        <Reveal delay={0.18} data-id="element-145">
          <p className="mt-5 text-lg leading-relaxed text-white/80" data-id="element-146">
            Esa presión que sube por tu garganta y no te deja dormir, trabajar o
            simplemente disfrutar de una comida con tu familia. Si estás cansado
            de tomar antiácidos que solo te alivian por una hora para que el
            dolor regrese{' '}
            <span className="font-semibold text-white" data-id="element-147">más fuerte</span>…
          </p>
        </Reveal>

        <Reveal delay={0.26} data-id="element-148">
          <p className="mt-6 inline-block border-b-2 border-[#e0611f] pb-1 font-display text-xl font-bold text-white sm:text-2xl" data-id="element-149">
            esto es para ti.
          </p>
        </Reveal>
      </div>
    </section>;
}